import React, { useState } from "react";
import PropTypes from "prop-types";

//
import { Modal, Button, Spinner } from "react-bootstrap";

//
import { deleteNotifications } from "../../redux/features/user/actions";
import { connect } from "react-redux";

function DeleteNotificationsModal({ show, setShow, deleteNotifications }) {
  const [loading, setLoading] = useState(false);

  // Delete All Messages
  const delete_notifications = async () => {
    // start loading
    setLoading(true);

    // request
    await deleteNotifications();

    // stop loading
    setLoading(false);

    // close modal
    setShow(false)
  };

  return (
    <Modal
      id="delete-messages-modal"
      centered
      size="lg"
      show={show}
      onHide={() => setShow(false)}
    >
      <Modal.Header>
        <h5>Delete Messages</h5>
        <p className="subject">
          Are you sure want to delete all messages? You will not be able to
          recover it.
        </p>
      </Modal.Header>

      <Modal.Body>
        <div className="actions p-0">
          <div className="back" onClick={() => setShow(false)}>
            Close
          </div>

          <Button
            variant="danger"
            size="lg"
            onClick={() => delete_notifications()}
          >
            Delete
            {loading && (
              <div className="spinner-holder">
                <Spinner animation="border" variant="white" size="sm" />
              </div>
            )}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

DeleteNotificationsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  deleteNotifications: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  deleteNotifications
}

export default connect(null , mapDispatchToProps)(DeleteNotificationsModal);
